import { Form, InputNumber } from "antd";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Spinner from "@src/components/spinner";
import { blockNonIntegerKeys, formatBreakDuration, splitBreakDuration } from "@src/util/breakDuration/breakDuration";
import { useQuery, useMutation } from "@apollo/client";
import { getScheduledJobById } from "@src/util/query/schedule.query";
import { useEffect, useState } from "react";
import { setNotification } from '@src/middleware/redux/reducers/notification.reducer';
import { updateScheduleMutation } from "@src/util/mutation/schedule.mutation";
import { useDispatch } from "react-redux";



export const EditDutyBreakTab = ({scheduleId}) =>{

    const {data: scheduledJobData, refetch: scheduleJobRefetch, loading: scheduledJobLoading} = useQuery(getScheduledJobById,{
        variables: {
            jobId: scheduleId
        },
        fetchPolicy: 'cache-and-network',
        skip: !scheduleId
    });
    

    const [jobData, setJobData] = useState({});

    useEffect(()=>{
        if(scheduledJobData?.getScheduledJobById?.response){
            setJobData({...scheduledJobData?.getScheduledJobById?.response});
        }
    },[scheduledJobData?.getScheduledJobById?.response]);

    // same HH / MM split as the Add / Edit Duty modal, saved back as "H:MM"
    const [unpaidBreakHour, setUnpaidBreakHour] = useState("");
    const [unpaidBreakMinute, setUnpaidBreakMinute] = useState("");
    const [unpaidBillHour, setUnpaidBillHour] = useState("");
    const [unpaidBillMinute, setUnpaidBillMinute] = useState("");

    useEffect(()=>{
        if(Object.keys(jobData)?.length>0){
            const unpaidBreak = splitBreakDuration(jobData?.unPaidBreakDuration);
            setUnpaidBreakHour(unpaidBreak.hour);
            setUnpaidBreakMinute(unpaidBreak.minute);

            const unpaidBill = splitBreakDuration(jobData?.unBillBreakDuration);
            setUnpaidBillHour(unpaidBill.hour);
            setUnpaidBillMinute(unpaidBill.minute);
        }
    },[jobData]);

    const dispatch = useDispatch();
    const [updateSchedule, {loading: updateScheduleLoading}] = useMutation(updateScheduleMutation);
    
    const handelBreak = async ()=>{
        try{

            await updateSchedule({
                variables:{
                    input:{
                        _id: scheduleId,
                        unPaidBreakDuration: formatBreakDuration(unpaidBreakHour, unpaidBreakMinute),
                        unBillBreakDuration: formatBreakDuration(unpaidBillHour, unpaidBillMinute),
                    }
                }
            });

            dispatch(setNotification({
                error: false,
                notificationState: true,
                message: "Break was updated successfully"
            }));
        }catch(err){
            dispatch(setNotification({
                error: true,
                notificationState: true,
                message: err.message
            }));
        }
    }


    return(
        <div  className="box-shadow border-radius">
            <div style={{padding:'16px'}}>
                <div className='hr-info-title'>
                   Duty Breaks
                </div>
            </div>

            {
                scheduledJobLoading || updateScheduleLoading?
                <div style={{display:'table', margin:'auto', textAlign:'center'}}>
                    <Spinner/>
                </div>

                :
                    <div style={{display:'flex', gap:'16px'}}>
                        <Form.Item style={{width:'49%'}}>
                            <label>Unpaid Break</label>
                            <div className="numberInput" style={{display:'flex', gap:'12px', margin:0, width:'100%'}}>
                                <InputNumber
                                    placeholder="HH"
                                    min={0}
                                    max={3}
                                    precision={0}
                                    onKeyDown={blockNonIntegerKeys}
                                    value={unpaidBreakHour}
                                    onChange={(e)=>setUnpaidBreakHour(e)}
                                    className="generic-input-control"
                                    style={{width:'100%'}}
                                    upHandler={<FontAwesomeIcon style={{color:'#0091ae'}} icon={faChevronUp} />}
                                    downHandler={<FontAwesomeIcon style={0 > 1 && {color:'#0091ae'}} icon={faChevronDown} />}
                                />
                                <InputNumber
                                    placeholder="MM"
                                    min={0}
                                    max={59}
                                    precision={0}
                                    onKeyDown={blockNonIntegerKeys}
                                    value={unpaidBreakMinute}
                                    onChange={(e)=>setUnpaidBreakMinute(e)}
                                    className="generic-input-control"
                                    style={{width:'100%'}}
                                    upHandler={<FontAwesomeIcon style={{color:'#0091ae'}} icon={faChevronUp} />}
                                    downHandler={<FontAwesomeIcon style={0 > 1 && {color:'#0091ae'}} icon={faChevronDown} />}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item style={{width:'49%'}}>
                            <label>Unbilled Break</label>
                            <div className="numberInput" style={{display:'flex', gap:'12px', margin:0, width:'100%'}}>
                                <InputNumber
                                    placeholder="HH"
                                    min={0}
                                    max={3}
                                    precision={0}
                                    onKeyDown={blockNonIntegerKeys}
                                    value={unpaidBillHour}
                                    onChange={(e)=>setUnpaidBillHour(e)}
                                    className="generic-input-control"
                                    style={{width:'100%'}}
                                    upHandler={<FontAwesomeIcon style={{color:'#0091ae'}} icon={faChevronUp} />}
                                    downHandler={<FontAwesomeIcon style={0 > 1 && {color:'#0091ae'}} icon={faChevronDown} />}
                                />
                                <InputNumber
                                    placeholder="MM"
                                    min={0}
                                    max={59}
                                    precision={0}
                                    onKeyDown={blockNonIntegerKeys}
                                    value={unpaidBillMinute}
                                    onChange={(e)=>setUnpaidBillMinute(e)}
                                    className="generic-input-control"
                                    style={{width:'100%'}}
                                    upHandler={<FontAwesomeIcon style={{color:'#0091ae'}} icon={faChevronUp} />}
                                    downHandler={<FontAwesomeIcon style={0 > 1 && {color:'#0091ae'}} icon={faChevronDown} />}
                                />
                            </div>
                        </Form.Item>
                    </div>
            }
            
            <div 
                className="drawer-footer border-radius-bottom"
                style={{display:'flex', alignItems:'right', justifyContent:'right', margin:'12px -10px -10px', }}
            >

                <button disabled={scheduledJobLoading || updateScheduleLoading}  className={scheduledJobLoading || updateScheduleLoading ? 'disabled-btn drawer-filled-btn':'drawer-filled-btn'} onClick={handelBreak}>
                    {scheduledJobLoading || updateScheduleLoading? <Spinner/> : "Save"}
                </button>

               

            </div>

        </div>
    )
};